export default "__VITE_ASSET__CSVXytmO__"